export default __webpack_public_path__ + "static/media/gokul-resume.39dc8404.pdf";